import _toConsumableArray from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import * as tslib_1 from "tslib";
import { isContinuous, isFieldDef, title } from '../channeldef';
import { extractTransformsFromEncoding } from '../encoding';
import * as log from '../log';
import { isMarkDef } from '../mark';
import { keys, titlecase } from '../util';
import { CompositeMarkNormalizer } from './base';
import { compositeMarkContinuousAxis, compositeMarkOrient, getCompositeMarkTooltip, makeCompositeAggregatePartFactory } from './common';
export var ERRORBAR = 'errorbar';
var ERRORBAR_PART_INDEX = {
  ticks: 1,
  rule: 1
};
export var ERRORBAR_PARTS = keys(ERRORBAR_PART_INDEX);
export var errorBarNormalizer = new CompositeMarkNormalizer(ERRORBAR, normalizeErrorBar);
export function normalizeErrorBar(spec, _ref) {
  var config = _ref.config;

  var _errorBarParams = errorBarParams(spec, ERRORBAR, config),
      transform = _errorBarParams.transform,
      continuousAxisChannelDef = _errorBarParams.continuousAxisChannelDef,
      continuousAxis = _errorBarParams.continuousAxis,
      encodingWithoutContinuousAxis = _errorBarParams.encodingWithoutContinuousAxis,
      ticksOrient = _errorBarParams.ticksOrient,
      markDef = _errorBarParams.markDef,
      outerSpec = _errorBarParams.outerSpec,
      tooltipEncoding = _errorBarParams.tooltipEncoding;

  var makeErrorBarPart = makeCompositeAggregatePartFactory(markDef, continuousAxis, continuousAxisChannelDef, encodingWithoutContinuousAxis, config.errorbar);
  var tick = {
    type: 'tick',
    orient: ticksOrient
  };
  return Object.assign({}, outerSpec, {
    transform: transform,
    layer: [].concat(_toConsumableArray(makeErrorBarPart({
      partName: 'ticks',
      mark: tick,
      positionPrefix: 'lower',
      extraEncoding: tooltipEncoding
    })), _toConsumableArray(makeErrorBarPart({
      partName: 'ticks',
      mark: tick,
      positionPrefix: 'upper',
      extraEncoding: tooltipEncoding
    })), _toConsumableArray(makeErrorBarPart({
      partName: 'rule',
      mark: 'rule',
      positionPrefix: 'lower',
      endPositionPrefix: 'upper',
      extraEncoding: tooltipEncoding
    })))
  });
}

function errorBarOrientAndInputType(spec, compositeMark) {
  var encoding = spec.encoding;

  if (errorBarIsInputTypeRaw(encoding)) {
    return {
      orient: compositeMarkOrient(spec, compositeMark),
      inputType: 'raw'
    };
  }

  var isTypeAggregatedUpperLower = errorBarIsInputTypeAggregatedUpperLower(encoding);
  var isTypeAggregatedError = errorBarIsInputTypeAggregatedError(encoding);
  var x = encoding.x;
  var y = encoding.y;

  if (isTypeAggregatedUpperLower) {
    // type is aggregated-upper-lower
    if (isTypeAggregatedError) {
      throw new Error(compositeMark + ' cannot be both type aggregated-upper-lower and aggregated-error');
    }

    var x2 = encoding.x2;
    var y2 = encoding.y2;

    if (isFieldDef(x2) && isFieldDef(y2)) {
      // having both x, x2 and y, y2
      throw new Error(compositeMark + ' cannot have both x2 and y2');
    } else if (isFieldDef(x2)) {
      if (isFieldDef(x) && isContinuous(x)) {
        // having x, x2 quantitative and field y, y2 are not specified
        return {
          orient: 'horizontal',
          inputType: 'aggregated-upper-lower'
        };
      } else {
        // having x, x2 that are not both quantitative
        throw new Error('Both x and x2 have to be quantitative in ' + compositeMark);
      }
    } else if (isFieldDef(y2)) {
      // y2 is a FieldDef
      if (isFieldDef(y) && isContinuous(y)) {
        // having y, y2 quantitative and field x, x2 are not specified
        return {
          orient: 'vertical',
          inputType: 'aggregated-upper-lower'
        };
      } else {
        // having y, y2 that are not both quantitative
        throw new Error('Both y and y2 have to be quantitative in ' + compositeMark);
      }
    }

    throw new Error('No ranged axis');
  } else {
    // type is aggregated-error
    var xError = encoding.xError;
    var xError2 = encoding.xError2;
    var yError = encoding.yError;
    var yError2 = encoding.yError2;

    if (isFieldDef(xError2) && !isFieldDef(xError)) {
      // having xError2 without xError
      throw new Error(compositeMark + ' cannot have xError2 without xError');
    }

    if (isFieldDef(yError2) && !isFieldDef(yError)) {
      // having yError2 without yError
      throw new Error(compositeMark + ' cannot have yError2 without yError');
    }

    if (isFieldDef(xError) && isFieldDef(yError)) {
      // having both xError and yError
      throw new Error(compositeMark + ' cannot have both xError and yError with both are quantiative');
    } else if (isFieldDef(xError)) {
      if (isFieldDef(x) && isContinuous(x)) {
        // having x and xError that are all quantitative
        return {
          orient: 'horizontal',
          inputType: 'aggregated-error'
        };
      } else {
        // having x, xError, and xError2 that are not all quantitative
        throw new Error('All x, xError, and xError2 (if exist) have to be quantitative');
      }
    } else if (isFieldDef(yError)) {
      if (isFieldDef(y) && isContinuous(y)) {
        // having y and yError that are all quantitative
        return {
          orient: 'vertical',
          inputType: 'aggregated-error'
        };
      } else {
        // having y, yError, and yError2 that are not all quantitative
        throw new Error('All y, yError, and yError2 (if exist) have to be quantitative');
      }
    }

    throw new Error('No ranged axis');
  }
}

function errorBarIsInputTypeRaw(encoding) {
  return (isFieldDef(encoding.x) || isFieldDef(encoding.y)) && !isFieldDef(encoding.x2) && !isFieldDef(encoding.y2) && !isFieldDef(encoding.xError) && !isFieldDef(encoding.xError2) && !isFieldDef(encoding.yError) && !isFieldDef(encoding.yError2);
}

function errorBarIsInputTypeAggregatedUpperLower(encoding) {
  return isFieldDef(encoding.x2) || isFieldDef(encoding.y2);
}

function errorBarIsInputTypeAggregatedError(encoding) {
  return isFieldDef(encoding.xError) || isFieldDef(encoding.xError2) || isFieldDef(encoding.yError) || isFieldDef(encoding.yError2);
}

export function errorBarParams(spec, compositeMark, config) {
  // TODO: use selection
  var mark = spec.mark,
      encoding = spec.encoding,
      selection = spec.selection,
      _p = spec.projection,
      outerSpec = tslib_1.__rest(spec, ["mark", "encoding", "selection", "projection"]);

  var markDef = isMarkDef(mark) ? mark : {
    type: mark
  }; // TODO(https://github.com/vega/vega-lite/issues/3702): add selection support

  if (selection) {
    log.warn(log.message.selectionNotSupported(compositeMark));
  }

  var _errorBarOrientAndInp = errorBarOrientAndInputType(spec, compositeMark),
      orient = _errorBarOrientAndInp.orient,
      inputType = _errorBarOrientAndInp.inputType;

  var _compositeMarkContinu = compositeMarkContinuousAxis(spec, orient, compositeMark),
      continuousAxisChannelDef = _compositeMarkContinu.continuousAxisChannelDef,
      continuousAxisChannelDef2 = _compositeMarkContinu.continuousAxisChannelDef2,
      continuousAxisChannelDefError = _compositeMarkContinu.continuousAxisChannelDefError,
      continuousAxisChannelDefError2 = _compositeMarkContinu.continuousAxisChannelDefError2,
      continuousAxis = _compositeMarkContinu.continuousAxis;

  var _errorBarAggregationA = errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config),
      errorBarSpecificAggregate = _errorBarAggregationA.errorBarSpecificAggregate,
      postAggregateCalculates = _errorBarAggregationA.postAggregateCalculates,
      tooltipSummary = _errorBarAggregationA.tooltipSummary,
      tooltipTitleWithFieldName = _errorBarAggregationA.tooltipTitleWithFieldName;

  var _a = continuousAxis,
      oldContinuousAxisChannelDef = encoding[_a],
      _b = continuousAxis === 'x' ? 'x2' : 'y2',
      oldContinuousAxisChannelDef2 = encoding[_b],
      _c = continuousAxis === 'x' ? 'xError' : 'yError',
      oldContinuousAxisChannelDefError = encoding[_c],
      _d = continuousAxis === 'x' ? 'xError2' : 'yError2',
      oldContinuousAxisChannelDefError2 = encoding[_d],
      oldEncodingWithoutContinuousAxis = tslib_1.__rest(encoding, [typeof _a === "symbol" ? _a : _a + "", typeof _b === "symbol" ? _b : _b + "", typeof _c === "symbol" ? _c : _c + "", typeof _d === "symbol" ? _d : _d + ""]);

  var _extractTransformsFro = extractTransformsFromEncoding(oldEncodingWithoutContinuousAxis, config),
      bins = _extractTransformsFro.bins,
      timeUnits = _extractTransformsFro.timeUnits,
      oldAggregate = _extractTransformsFro.aggregate,
      oldGroupBy = _extractTransformsFro.groupby,
      encodingWithoutContinuousAxis = _extractTransformsFro.encoding;

  var aggregate = [].concat(_toConsumableArray(oldAggregate), _toConsumableArray(errorBarSpecificAggregate));
  var groupby = inputType !== 'raw' ? [] : oldGroupBy;
  var tooltipEncoding = getCompositeMarkTooltip(tooltipSummary, continuousAxisChannelDef, encodingWithoutContinuousAxis, tooltipTitleWithFieldName);
  return {
    transform: [].concat(_toConsumableArray(outerSpec.transform || []), _toConsumableArray(bins), _toConsumableArray(timeUnits), _toConsumableArray(!aggregate.length ? [] : [{
      aggregate: aggregate,
      groupby: groupby
    }]), _toConsumableArray(postAggregateCalculates)),
    groupby: groupby,
    continuousAxisChannelDef: continuousAxisChannelDef,
    continuousAxis: continuousAxis,
    encodingWithoutContinuousAxis: encodingWithoutContinuousAxis,
    ticksOrient: orient === 'vertical' ? 'horizontal' : 'vertical',
    markDef: markDef,
    outerSpec: outerSpec,
    tooltipEncoding: tooltipEncoding
  };
}

function errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config) {
  var errorBarSpecificAggregate = [];
  var postAggregateCalculates = [];
  var continuousFieldName = continuousAxisChannelDef.field;
  var tooltipSummary;
  var tooltipTitleWithFieldName = false;

  if (inputType === 'raw') {
    var center = markDef.center ? markDef.center : markDef.extent ? markDef.extent === 'iqr' ? 'median' : 'mean' : config.errorbar.center;
    var extent = markDef.extent ? markDef.extent : center === 'mean' ? 'stderr' : 'iqr';

    if (center === 'median' !== (extent === 'iqr')) {
      log.warn(log.message.errorBarCenterIsUsedWithWrongExtent(center, extent, compositeMark));
    }

    if (extent === 'stderr' || extent === 'stdev') {
      errorBarSpecificAggregate = [{
        op: extent,
        field: continuousFieldName,
        as: 'extent_' + continuousFieldName
      }, {
        op: center,
        field: continuousFieldName,
        as: 'center_' + continuousFieldName
      }];
      postAggregateCalculates = [{
        calculate: "datum[\"center_".concat(continuousFieldName, "\"] + datum[\"extent_").concat(continuousFieldName, "\"]"),
        as: 'upper_' + continuousFieldName
      }, {
        calculate: "datum[\"center_".concat(continuousFieldName, "\"] - datum[\"extent_").concat(continuousFieldName, "\"]"),
        as: 'lower_' + continuousFieldName
      }];
      tooltipSummary = [{
        fieldPrefix: 'center_',
        titlePrefix: titlecase(center)
      }, {
        fieldPrefix: 'upper_',
        titlePrefix: getTitlePrefix(center, extent, '+')
      }, {
        fieldPrefix: 'lower_',
        titlePrefix: getTitlePrefix(center, extent, '-')
      }];
      tooltipTitleWithFieldName = true;
    } else {
      if (markDef.center && markDef.extent) {
        log.warn(log.message.errorBarCenterIsNotNeeded(markDef.extent, compositeMark));
      }

      var centerOp;
      var lowerExtentOp;
      var upperExtentOp;

      if (extent === 'ci') {
        centerOp = 'mean';
        lowerExtentOp = 'ci0';
        upperExtentOp = 'ci1';
      } else {
        centerOp = 'median';
        lowerExtentOp = 'q1';
        upperExtentOp = 'q3';
      }

      errorBarSpecificAggregate = [{
        op: lowerExtentOp,
        field: continuousFieldName,
        as: 'lower_' + continuousFieldName
      }, {
        op: upperExtentOp,
        field: continuousFieldName,
        as: 'upper_' + continuousFieldName
      }, {
        op: centerOp,
        field: continuousFieldName,
        as: 'center_' + continuousFieldName
      }];
      tooltipSummary = [{
        fieldPrefix: 'upper_',
        titlePrefix: title({
          field: continuousFieldName,
          aggregate: upperExtentOp,
          type: 'quantitative'
        }, config, {
          allowDisabling: false
        })
      }, {
        fieldPrefix: 'lower_',
        titlePrefix: title({
          field: continuousFieldName,
          aggregate: lowerExtentOp,
          type: 'quantitative'
        }, config, {
          allowDisabling: false
        })
      }, {
        fieldPrefix: 'center_',
        titlePrefix: title({
          field: continuousFieldName,
          aggregate: centerOp,
          type: 'quantitative'
        }, config, {
          allowDisabling: false
        })
      }];
    }
  } else {
    if (markDef.center || markDef.extent) {
      log.warn(log.message.errorBarCenterAndExtentAreNotNeeded(markDef.center, markDef.extent));
    }

    if (inputType === 'aggregated-upper-lower') {
      tooltipSummary = [];
      postAggregateCalculates = [{
        calculate: "datum[\"".concat(continuousAxisChannelDef2.field, "\"]"),
        as: 'upper_' + continuousFieldName
      }, {
        calculate: "datum[\"".concat(continuousFieldName, "\"]"),
        as: 'lower_' + continuousFieldName
      }];
    } else if (inputType === 'aggregated-error') {
      tooltipSummary = [{
        fieldPrefix: '',
        titlePrefix: continuousFieldName
      }];
      postAggregateCalculates = [{
        calculate: "datum[\"".concat(continuousFieldName, "\"] + datum[\"").concat(continuousAxisChannelDefError.field, "\"]"),
        as: 'upper_' + continuousFieldName
      }];

      if (continuousAxisChannelDefError2) {
        postAggregateCalculates.push({
          calculate: "datum[\"".concat(continuousFieldName, "\"] + datum[\"").concat(continuousAxisChannelDefError2.field, "\"]"),
          as: 'lower_' + continuousFieldName
        });
      } else {
        postAggregateCalculates.push({
          calculate: "datum[\"".concat(continuousFieldName, "\"] - datum[\"").concat(continuousAxisChannelDefError.field, "\"]"),
          as: 'lower_' + continuousFieldName
        });
      }
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = postAggregateCalculates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var postAggregateCalculate = _step.value;
        tooltipSummary.push({
          fieldPrefix: postAggregateCalculate.as.substring(0, 6),
          titlePrefix: postAggregateCalculate.calculate.replace(new RegExp('datum\\[\\"', 'g'), '').replace(new RegExp('\\"\\]', 'g'), '')
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return {
    postAggregateCalculates: postAggregateCalculates,
    errorBarSpecificAggregate: errorBarSpecificAggregate,
    tooltipSummary: tooltipSummary,
    tooltipTitleWithFieldName: tooltipTitleWithFieldName
  };
}

function getTitlePrefix(center, extent, operation) {
  return titlecase(center) + ' ' + operation + ' ' + extent;
}